module.exports = __webpack_public_path__ + "img/banner01.3147b7c7.png";